import React, { PropTypes } from 'react';

function kLargest(arr, k) {
	const out = [];
	// Sort the given array arr in reverse order.
	arr.sort((a, b) => b - a);

	// Print the first kth largest elements
	for (let i = 0; i < k; i++) {
		out.push(arr[i]);
	}

	return out.reverse();
}

export default class Cluster extends React.Component {
	
	getSize() {
		const { allClusters, numPoints } = this.props;

		var pointsQuantities = new Set();
		allClusters.map(c => pointsQuantities.add(c.numPoints));
		const listPointsQuantities = Array.from(pointsQuantities);

		const steps = kLargest(listPointsQuantities, 5);
		
		let pos = 0;
		for (let i = 0; i < 5; i++) {
			if (numPoints >= steps[i]) {
				pos = i;
			}
		}
		return pos + 1;
	}

	// tem que ser uma dessas opções!
	// /m1.png  /m2.png  /m3.png  /m4.png /m5.png
	render() {
		const { numPoints } = this.props;

		const size = `m${this.getSize()}`;
		const imageUrl = `/${size}.png`;

		return (
			<div className="pin-cluster" onClick={() => this.props.onClick()}>	
				<img className={size} src={imageUrl}></img>
				<div className={size}>{numPoints}</div>
			</div>
		);
	}
}

Cluster.propTypes = {
	allClusters: PropTypes.array.isRequired,
	numPoints: PropTypes.number.isRequired,
	onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/Markers/Cluster.js